import hcaThumb from '../assets/images/hca-thumb.jpg';
import cnaBridge from '../assets/images/cna-bridge.jpg';
import ndthumb from '../assets/images/ND-thumb.jpg';
import HIVthumb from '../assets/images/HIV-thumb.jpg';
import orientationsafety from '../assets/images/orientationsafety.jpg';
import dementia from '../assets/images/dementia-care.jpg';

const courseData = [

   {
      id: 1,
      title: "CNA BRIDGE PROGRAM",
      image: cnaBridge,
      description: "Transition from HCA to CNA with our comprehensive bridge program.",
      hours: "75 hours",
      /*price: "$599",/*/
      slug: "cna-bridge"
    },
    {
      id: 2,
      title: "HOME CARE AIDE",
      image: hcaThumb,
      description: "Comprehensive training for home care aides covering all essential skills.",
      hours: "75 hours",
      /*price: "$499",/*/
      slug: "home-care-aide"
    },
   
    {
      id: 3,
      title: "NURSE DELEGATION",
      image: ndthumb,
      description: "Training for nurses on delegation tasks to nursing assistants.",
      hours: "6 hours",
      /*price: "$199",/*/
      slug: "nurse-delegation"
    },
    {
      id: 4,
      title: "HIV/AIDS TRAINING",
      image: HIVthumb,
      description: "Specialized training on HIV/AIDS care and prevention.",
      hours: "7 hours",
      /*price: "$149",*/
      slug: "hiv-aids"
    },
    {
      id: 5,
      title: "ORIENTATION & SAFETY",
      image: orientationsafety,
      description: "Essential orientation and safety procedures for healthcare workers.",
      hours: "8 hours",
      /*price: "$129",*/
      slug: "orientation-safety"
    },
    {
      id: 6,
      title: "DEMENTIA CARE",
      image: dementia,
      description: "Specialized training for caring for patients with dementia.",
      hours: "12 hours",
      /*price: "$249",/*/
      slug: "dementia-care"
    }
  ];
  
  export default courseData;